import { navigate } from "gatsby";
import React from "react";
import ReactMarkdown from "react-markdown";

import * as styles from "../styles/Card.module.css";

export interface CardProps {
  onClick?: () => void;
  src?: string;
  svg?: any;
  title?: string;
  text?: string;
  learnMore?: string;
  alt?: string;
}
const link = (url?: string) => {
  if (url) {
    navigate(url);
  }
};

const Card = (props: CardProps) => {
  return (
    <div
      style={{ cursor: props.onClick ? "pointer" : undefined }}
      className={styles.container}
      onClick={props.onClick}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          textAlign: "center",
        }}
      >
        {props.svg ? (
          <div
            className={styles.card_img}
            style={{ width: 100, height: 100 }}
            onClick={() => link(props.learnMore)}
          >
            <props.svg />
          </div>
        ) : (
          <img
            className={styles.card_img}
            src={props.src}
            alt={props.alt}
            onClick={() => link(props.learnMore)}
          />
        )}

        <div style={{ marginLeft: "auto", marginRight: "auto" }}>
          <h3 className={styles.title}>{props.title}</h3>
          {/* @ts-ignore */}
          <ReactMarkdown className={styles.text}>{props.text}</ReactMarkdown>
        </div>
        {props.learnMore && (
          <button
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "auto",
            }}
            className="button button-secondary"
            onClick={() => link(props.learnMore)}
          >
            Learn More
          </button>
        )}
      </div>
    </div>
  );
};

export default Card;
